import { createApp } from 'vue'
import App from './App.vue'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'
import i18n from './i18n'
import { createPinia } from 'pinia' 


createApp(App).use(i18n).use(Quasar, quasarUserOptions).use(createPinia()).mount('#app')

